import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private platformId = inject(PLATFORM_ID);
  private readonly _storageKey = 'theme';
  private _theme = signal<'light' | 'dark'>('light');
  theme$ = this._theme.asReadonly();

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const saved = localStorage.getItem(this._storageKey) as
        | 'light'
        | 'dark'
        | null;
      this.setTheme(saved ?? 'light');
    }
  }

  public get current(): 'light' | 'dark' {
    if (!isPlatformBrowser(this.platformId)) {
      return 'light';
    }
    return document.documentElement.classList.contains('dark-mode')
      ? 'dark'
      : 'light';
  }

  public toggle(theme: 'light' | 'dark'): void {
    this.setTheme(theme);
  }

  public setTheme(theme: 'light' | 'dark'): void {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
    }
    this._theme.set(theme);
    localStorage.setItem(this._storageKey, theme);
  }
}
